import { c as _c } from "react/compiler-runtime";
import type { ImageComparisonColor, ImageComparisonValue } from '@onefootprint/request-types/smart-blocks';
import { Badge } from '@onefootprint/ui';
import { cx } from 'class-variance-authority';
const textColor: Record<ImageComparisonColor, string> = {
  neutral: 'text-primary',
  success: 'text-success',
  warning: 'text-warning',
  error: 'text-error',
  info: 'text-info'
};
const formatValue = (value: ImageComparisonValue) => {
  if (value.value === null) return '—';
  if (value.type === 'boolean') return value.value ? 'Yes' : 'No';
  if (value.type === 'tags') return value.value.join(', ');
  if (typeof value.value === 'number') return `${new Intl.NumberFormat('en-US', {
    maximumFractionDigits: 20
  }).format(value.value)}${value.type === 'percentage' ? '%' : ''}`;
  return value.value;
};
const ComparisonValueDisplay = t0 => {
  const $ = _c(15);
  const {
    value,
    compact: t1
  } = t0;
  const compact = t1 === undefined ? false : t1;
  if (value.type === "label" && value.value !== null) {
    const t2 = value.color ?? "neutral";
    const t3 = compact ? "truncate" : undefined;
    let t4;
    if ($[0] !== t3 || $[1] !== value.value) {
      t4 = <span className={t3}>{value.value}</span>;
      $[0] = t3;
      $[1] = value.value;
      $[2] = t4;
    } else {
      t4 = $[2];
    }
    let t5;
    if ($[3] !== t2 || $[4] !== t4) {
      t5 = <Badge variant={t2} className="max-w-full px-2 py-0.5 text-caption-2">{t4}</Badge>;
      $[3] = t2;
      $[4] = t4;
      $[5] = t5;
    } else {
      t5 = $[5];
    }
    return t5;
  }
  const t2 = compact ? "block truncate" : "break-words";
  const t3 = textColor[value.color ?? "neutral"];
  const t4 = value.type === "score" && "font-medium";
  let t5;
  if ($[6] !== t2 || $[7] !== t3 || $[8] !== t4) {
    t5 = cx("tabular-nums", t2, t3, t4);
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== value) {
    t6 = formatValue(value);
    $[10] = value;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5 || $[13] !== t6) {
    t7 = <span className={t5}>{t6}</span>;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};
export default ComparisonValueDisplay;